import { Component } from '@angular/core';

@Component({
  selector: 'app-viewflattedgala',
  templateUrl: './viewflattedgala.component.html',
  styleUrl: './viewflattedgala.component.css'
})
export class ViewflattedgalaComponent {

}
